import React from 'react';
import { Box, Typography } from '@mui/material';

export interface SidebarItem {
  label: string;
  quantity?: number;
}

interface SelectionSidebarProps {
  count: number;
  countLabel: string;
  subLabel?: string;
  items: SidebarItem[];
  emptyHint: string;
}

const SelectionSidebar: React.FC<SelectionSidebarProps> = ({
  count,
  countLabel,
  subLabel,
  items,
  emptyHint,
}) => {
  return (
    <Box>
      <Typography
        variant="overline"
        sx={{
          fontWeight: 700,
          letterSpacing: '0.08em',
          color: 'text.secondary',
          fontSize: '0.72rem',
          display: 'block',
        }}
      >
        Ihre Auswahl
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 0.5 }}>
        <Typography
          component="span"
          sx={{
            fontSize: '2.4rem',
            lineHeight: 1,
            fontWeight: 800,
            color: 'primary.main',
          }}
        >
          {count}
        </Typography>
        <Typography component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
          {countLabel}
        </Typography>
      </Box>

      {subLabel && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {subLabel}
        </Typography>
      )}

      {items.length === 0 ? (
        <Box
          sx={{
            mt: 2.5,
            p: 2.5,
            border: '1.5px dashed',
            borderColor: 'grey.400',
            borderRadius: '12px',
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {emptyHint}
          </Typography>
        </Box>
      ) : (
        <>
          <Box sx={{ mt: 2.5, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            {items.map((item) => (
              <Box
                key={item.label}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.25,
                  bgcolor: '#fff',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: '10px',
                  px: 1.75,
                  py: 1.25,
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    flexShrink: 0,
                  }}
                />
                <Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>
                  {item.label}
                </Typography>
                {item.quantity !== undefined && (
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: 'text.secondary',
                      bgcolor: 'grey.100',
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: '6px',
                      px: 0.75,
                      py: 0.25,
                    }}
                  >
                    ×{item.quantity}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              mt: 2.5,
              p: 2,
              bgcolor: '#E8F1FB',
              borderRadius: '12px',
            }}
          >
            <Typography variant="body2" sx={{ color: 'text.primary' }}>
              ✓ Alles in <strong>einem</strong> Angebot — Sie müssen den Rechner nur einmal
              ausfüllen.
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default SelectionSidebar;
